// extracted by mini-css-extract-plugin
export var createdDate = "_mf-1";
export var divider = "_mf-2";
export var headerDivider = "_mf-3";
export var messagesCard = "_mf-0";
export var messagesContainer = "_mf-7";
export var messagesContainerWrapper = "_mf-4";
export var pointerCapturingButtonBoxes = "_mf-a";
export var showLeftPanelButton = "_mf-9";
export var showMoreButton = "_mf-c";
export var showMoreButtonContainer = "_mf-b";
export var summaryTitle = "_mf-6";
export var systemMessageCardWrapper = "_mf-d";
export var topButtons = "_mf-8";
export var withPadding = "_mf-5";